var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',[_c('el-tabs',{attrs:{"type":"card"}},[_c('el-tab-pane',{attrs:{"label":"失物列表"}},[_c('Lost')],1),_c('el-tab-pane',{attrs:{"label":"寻物申请"}},[_c('Seek')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }